import { FormikValues, useFormikContext } from 'formik';
import React, { ChangeEvent, useEffect, useState } from 'react';

import Ajuda from './Ajuda';
import Grupo from './Grupo';

interface Props {
    ajuda?: string;
    name: string;
    rotulo?: string;
    semMargem?: boolean;
    value?: string | number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    forcarValor?: any;
    desabilitarAoForcar?: boolean;
}

const CaixaDeSelecao = (props: Props): React.ReactElement =>
{
    const [ desabilitado, setDesabilitado ] = useState<boolean>(false);
    const { ajuda, name, rotulo, semMargem, value = 1, forcarValor, desabilitarAoForcar = true } = props;
    const { errors, touched, setFieldTouched, setFieldValue, getFieldMeta } = useFormikContext<FormikValues>();
    const meta = getFieldMeta(name);

    useEffect(() => {
        if (isNaN(meta.value as number)) {
          setFieldValue(name, meta.value || 0, false);
        }
    }, [name, setFieldValue, meta]);

    useEffect(() => {
        if (forcarValor && !meta.value) {
            setFieldValue(name, forcarValor, true);

            if (desabilitarAoForcar) {
                setDesabilitado(true);
            }
        }
    }, [desabilitarAoForcar, name, forcarValor, setFieldValue, meta]);

    const manipulador = (evento: ChangeEvent<HTMLInputElement>) =>
    {
        setFieldTouched(name, true, true);

        if (evento.target.checked) {
            setFieldValue(name, value, true);
        } else {
            setFieldValue(name, 0, true);
        }
    }

    return (
        <Grupo semMargem={ semMargem } emLinha={ false }>
            <div className="form-check form-switch">
                <input
                    type="checkbox"
                    name={ name }
                    className={ `form-check-input ${ errors[name] && touched[name] && 'is-invalid' }` }
                    onChange={ manipulador }
                    value={ value }
                    checked={ meta.value ? true : false }
                    {...desabilitado ? { disabled: true } : {}}
                />
                <label className="form-check-label ms-3" htmlFor={ name }>
                    { rotulo }
                </label>
            </div>
            <React.Fragment>
                { ajuda && (
                    <Ajuda>{ ajuda }</Ajuda>
                ) }
            </React.Fragment>
            <div className="invalid-tooltip">
                { errors[name] && touched[name] && errors[name] }
            </div>
        </Grupo>
    );
}

export default CaixaDeSelecao;
